import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-comissions',
  templateUrl: './comissions.component.html',
  styleUrls: ['./comissions.component.css']
})
export class ComissionsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
